module.exports = __webpack_public_path__ + "img/edit.abc3d7a9.svg";